import axios from 'axios'

export const submitReport = (payload: object) => axios.post('v1/catalogo/pregnancy-report', payload)
